<template>
  <v-app-bar id="app-bar" absolute app color="transparent" flat height="75">
    <!--
    <v-btn
      class="mr-3"
      elevation="1"
      fab
      small
      @click="toggleDrawer()"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
    />
    -->

    <v-spacer />

    <v-menu bottom left offset-y origin="top right" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">
          <span v-if="activeProject">{{ activeProject.name }}</span>
          <span v-if="!activeProject">No Workspace</span>
          <v-icon class="ml-4">mdi-folder</v-icon>
        </v-btn>
      </template>

      <v-list :tile="false" nav>
        <div>
          <div v-if="projects.length<=0" class="text-center pa-4">
            <p>You don't have a Workspace.</p>
            <v-btn small outlined color="primary" to="account">Create Workspace</v-btn>
          </div>
          <app-bar-item v-for="(item, i) in projects" :key="`project-${i}`">
            <v-list-item-title v-text="item.name" @click="setActiveProject(item)" />
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>

    <!--
    <v-menu bottom left offset-y origin="top right" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn class="mx-2" min-width="0" text v-bind="attrs" v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list :tile="false" nav>
        <div>
          <app-bar-item>
            <v-list-item-title @click="setDarkMode">Light mode</v-list-item-title>
          </app-bar-item>
          <app-bar-item>
            <v-list-item-title @click="signOut">{{ $t('signOut') }}</v-list-item-title>
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>
    -->

    <v-menu
      :close-on-content-click="false"
      bottom left offset-y origin="top right" transition="scale-transition"
      content-class="elevation-0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mx-2" min-width="0" text v-bind="attrs" v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-card class="ma-0 py-5" width="250">
        <v-list>
          <v-list-item>
            <!--
            <v-list-item-action>
              <v-switch
                :input-value="$vuetify.theme.dark"
                @change="setDarkMode"
                color="purple"
                inset
              ></v-switch>
            </v-list-item-action>
            <v-list-item-title>Dark mode</v-list-item-title>
            -->
            
            <v-select
              :value="$vuetify.theme.dark"
              :items="theme"
              :label="$t('theme')"
              @change="setDarkMode"
              outlined
              dense
            />
          </v-list-item>

          <v-list-item>
            <v-select
              :value="$root.$i18n.locale"
              :items="languages"
              :label="$t('language')"
              @change="setLanguage"
              outlined
              dense
            />
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            @click="signOut"
          >
            {{ $t('signOut') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
// Components
import { VHover, VListItem } from "vuetify/lib";

// Utilities
import { mapState } from "vuex";

export default {
  name: "DashboardCoreAppBar",

  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover,
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                },
                this.$slots.default
              );
            },
          },
        });
      },
    },
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      languages: [
        { text: 'English', value: 'en' },
        { text: 'Svenska', value: 'sv' },
      ]
    }
  },

  computed: {
    ...mapState(["drawer"]),

    user() {
      return this.$store.getters["user/getUser"];
    },

    projects() {
      return this.$store.getters["projects/getProjects"];
    },

    activeProject() {
      return this.$store.getters["projects/getActiveProject"];
    },

      theme() {
        return [{ text: this.$i18n.t('themeDark'), value: true },{ text: this.$i18n.t('themeLight'), value: false }];
      },
  },

  methods: {
    setActiveProject(item) {
      if (item.id) {
        this.$store.dispatch("projects/setActiveProject", item.id);
      }
    },
    toggleDrawer() {
      this.$store.dispatch("common/toggleDrawer");
    },
    signOut () {
      this.$authService.authSignOut()
    },
    setDarkMode (isDarkMode) {
      this.$vuetify.theme.dark = isDarkMode
      localStorage.setItem('darkMode', isDarkMode)
    },
    setLanguage (lang) {
      this.$root.$i18n.locale = lang
      localStorage.setItem('language', lang)
    },
  },
};
</script>
